import { START_LOADING, END_LOADING } from "./loading_actions";
import { postPasswordResetConfirm } from "../../utils/api";
import { SET_PORTAL_API } from "./portal_actions";
import { TITLE_NOTIFICATION, TEXT_RESET_PASSWORD, TITLE_ERROR } from "../../utils/constants";

export const EDIT_NEW_PASSWORD = 'EDIT_NEW_PASSWORD';
export const EDIT_RE_NEW_PASSWORD = 'EDIT_RE_NEW_PASSWORD';
export const RESET_CONFIRM_PASSWORD_FORM = 'RESET_CONFIRM_PASSWORD_FORM';
export const REQUEST_CONFIRM_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const REQUEST_CONFIRM_PASSWORD_SUCCESS = 'REQUEST_CONFIRM_PASSWORD';
export const REQUEST_CONFIRM_PASSWORD_FAILED = 'REQUEST_CONFIRM_PASSWORD_FAILED';

export const postPasswordResetConfirmThunk = (
  navigate, uid, token, new_password, re_new_password
) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_CONFIRM_PASSWORD });
    postPasswordResetConfirm(uid, token, new_password, re_new_password)
    .then(data => {
      dispatch({ type: REQUEST_CONFIRM_PASSWORD_SUCCESS });
      navigate("/login", { replace: true });
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_NOTIFICATION,
        text: TEXT_RESET_PASSWORD
      });
    })
    .catch(error => {
      console.log(error);
        dispatch({ type: REQUEST_CONFIRM_PASSWORD_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
        navigate("/", { replace: true });
    })
    .finally(() => {
      dispatch({ type: END_LOADING });
    });
  }
}
